"use client"; // Because you are using hooks and client state

import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import FaqsStylistCard from "../../src/components/StylistDescriptionCard/FaqsStylistCard.js";
import { listCoupon } from "../../src/actions/couponActions.js";
import { useDispatch, useSelector } from "react-redux";
import SliderBannerShowData from "../../src/components/slider/sliderBanner.js";
import { listFaqs } from "../../src/actions/faqsAction.js";
import Link from "next/link";
import ChatPopup from "../../src/components/home/ChatPopup.js";


const Item = styled(
  Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));



// Reusable FAQ Button Component with Responsive Design
const FAQButton = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="mt-2">
      <button
        className={`flex justify-between w-full px-4 py-3 text-left focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75
          text-gray-600 bg-gray-50 hover:bg-emerald-50 rounded-lg 
          text-base md:text-lg lg:text-base`}  // Increase text size on mobile and tablet
        type="button"
        onClick={onClick}  // Trigger toggle when clicked
      >
        <span>{question}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          className={`w-5 h-5 text-gray-500 transition-transform transform ${isOpen ? 'rotate-180' : ''}`}
        >
          <path
            fillRule="evenodd"
            d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {/* Conditionally render the answer if the question is open */}
      {isOpen && (
        <div className="mt-2 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg">
          {answer}
        </div>
      )}
    </div>
  );
};

function TermsConditions() {

  const classes = useStyles();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const dispatch = useDispatch();
  const couponList = useSelector((state) => state.couponList);
  const { error, loading, coupons } = couponList;

  // const privacyPolicyList = useSelector((state)=>state.privacyPolicyList);
  // const {error1,loading1,privacyPolicy} =privacyPolicyList;

  // useEffect(()=>{
  //   dispatch(listCoupon());
  //   dispatch(listPrivacyPolicy());
  // },[dispatch])

  const FaqsQAList = useSelector((state) => state.FaqsQAList);
  const { error1, loading1, faqsQA } = FaqsQAList;


  useEffect(() => {
    dispatch(listCoupon());
    dispatch(listFaqs());
  }, [dispatch])



  const [showScrollButton, setShowScrollButton] = useState(false);

  // Effect for scrolling behavior
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Function to scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };






  const [openIndex, setOpenIndex] = useState(null); // Track which FAQ is open (null means none are open)

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


  const twoCupon = coupons.result ? coupons.result.slice(0, 2) : []






  
  return (
    <>
      <ChatPopup />
          
          
          <div className="bg-gray-50">
         
        <div className="flex justify-center py-10 lg:py-20 bg-indigo-100 w-full bg-cover bg-no-repeat bg-bottom" 
            style={{ backgroundImage: `url('/assets/Blog/BlogHeader.jpg')` }}>
            <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
                <div className="w-full flex justify-center flex-col relative">
                    <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold font-serif text-center text-pink-600">Privacy Policy</h2>
                </div>
            </div>
        </div>
      
      <div className="bg-white">
        <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-5 sm:px-10">


        {/* <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} > */}
            
          {/* <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}> */}
           

          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >
          Last updated: February 15, 2022</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
          At Door to Door Beauty, accessible from Door to Door Beauty dot com, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Door to Door Beauty and how we use it. If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide. When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
          This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in Door to Door Beauty.we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number. This policy is not applicable to any information collected offline or via channels other than this website. Our Privacy Policy was created with the help of the Free Privacy Policy Generator.
          </p>

          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >
          Consent</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            By using our website, you hereby consent to our Privacy Policy and agree to its terms.
          </p>

          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >Information we collect</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information. If you contact us directly, we may receive additional information about you such may choose to provide. When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
          Please note that the Company will not ask you to share any sensitive data or information via email or telephone. If you receive any such request by email or telephone, please do not respond/divulge any sensitive data or information and forward the information relating to the same to
          </p>


          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >How we use your information</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            We use the information we collect in various ways, including to:
          </p>
          <ul style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625", margin: "0 0 10px", paddingLeft: "40px", listStyleType: "decimal",}}>
            <li style={{ marginBottom: "10px" }}> Provide, operate, and maintain our website, to provide you with updates and other information.</li>
            <li style={{ marginBottom: "10px" }}> Improve, personalize, and expand our website,and other information relating to the website.</li>
            <li style={{ marginBottom: "10px" }}> Understand and analyze how you use our website, to provide you with updates and other information relating to the website.</li>
            <li style={{ marginBottom: "10px" }}> Develop new products, services, features, and functionality,and other information relating to the website.</li>
            <li style={{ marginBottom: "10px" }}> Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates.</li>
            <li style={{ marginBottom: "10px" }}> Send you emails. To provide you with updates and other information relating to the website, and for marketing and promotional purposes</li>
            <li style={{ marginBottom: "10px" }}> Find and prevent fraud. To provide you with updates and other information relating to the website, and for marketing and promotional purposes</li>
          </ul>

          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >Log Files</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
              Door to Door Beauty follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.
          </p>

          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >Advertising Partners Privacy Policies</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            You may consult this list to find the Privacy Policy for each of the advertising partners of Door to Door Beauty. Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Door to Door Beauty, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit. Note that Door to Door Beauty has no access to or control over these cookies that are used by third-party advertisers.
          </p>

          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >Third Party Privacy Policies</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Door to Door Beauty, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit. Note that Door to Door Beauty has no access to or control over these cookies that are used by third-party advertisers.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
          Door to Door Beauty's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.
          </p>

          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >CCPA Privacy Rights</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
          Under the CCPA, among other rights, California consumers have the right to: Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers. Request that a business delete any personal data about the consumer that a business has collected. Request that a business that sells a consumer's personal data, not sell the consumer's personal data. If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.          </p>
         
          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >Children's Information</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
          Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.Request that a business delete any personal data about the consumer that a business has collected. If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
          Door to Door Beauty does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.
          </p>
        </div>
      </div>
   
   
      {/* <FaqsStylistCard /> <br /><br /> */}
    </div>
    
          
       


      


      {/* Rest of your component code goes here */}

      {/* Scroll-to-Top Button */}
      {showScrollButton && (
        <button
          className="fixed bottom-[100px] right-8 bg-pink-600 hover:bg-emerald-600 text-white p-3 rounded-full shadow-lg"
          onClick={scrollToTop}
        >
          ⬆️
        </button>
      )}
    </>
  );
}

export default TermsConditions;
